export default __webpack_public_path__ + "static/media/q2_2_step5.8ff266a2.png";